import { z } from "zod";
import { lenientArray, strings, text } from "./common";
import { WEEK_TONES, periodDaySchema, weekAreaSchema } from "./week";

export const FORECAST_PERIODS = ["day", "week", "month"] as const;
export type ForecastPeriod = (typeof FORECAST_PERIODS)[number];

const EMPTY_RANGE = { start: "", end: "", label: "" };
const EMPTY_SIGNS = { moon_sign: "", moon_rashi: "", lagna: "", lagna_rashi: "" };

/** How the tradition reads a single day from the Moon. Only a day has one. */
const moonNoteSchema = z.object({ tone: z.enum(WEEK_TONES).catch("steady"), reason: text() }).nullable().catch(null);

/**
 * `GET /me/forecast?period=`: the signed-in person's day, week or month, in
 * the same four areas as the first-run week.
 */
export const forecastSchema = z.object({
  period: z.enum(FORECAST_PERIODS).catch("day"),
  range: z.object({ start: text(), end: text(), label: text() }).catch(EMPTY_RANGE),
  signs: z.object({ moon_sign: text(), moon_rashi: text(), lagna: text(), lagna_rashi: text() }).catch(EMPTY_SIGNS),
  headline: text(),
  areas: lenientArray(weekAreaSchema),
  best_days: strings(),
  careful_days: strings(),
  days: lenientArray(periodDaySchema),
  moon: moonNoteSchema,
  /** True for a locked account's day: the headline only, the reading held back. */
  preview: z.boolean().catch(false),
  written_by: text(),
});
export type Forecast = Readonly<z.output<typeof forecastSchema>>;
export type MoonNote = NonNullable<Forecast["moon"]>;
